var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mainHeader'),_c('sideMenu',{attrs:{"studyData":_vm.studyData}}),_c('div',{staticClass:"has-sidemenu has-header"},[_c('router-view',{attrs:{"studyData":_vm.studyData,"studyId":_vm.studyId,"siteId":_vm.siteId}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }